import { environment } from '../environments/environment';
import { StateService } from '@ecosure-suite/common/util-state-management';


export const dashboardItems = [
  environment.modules.burialSocieties
    ? {
      title: 'Burial Societies',
      smallText: 'EcoSure',
      url: '/burial-societies',
      icon: 'fa fa-users',
      type: 'primary'
    }
    : undefined,
  environment.modules.individuals && environment.state === 'BW'
    ? {
      title: 'Karabo',
      smallText: 'Individuals',
      url: '/individuals',
      icon: 'fa fa-user',
      type: 'primary'
    }
    : {
      title: 'Individuals',
      smallText: 'EcoSure',
      url: '/individuals',
      icon: 'fa fa-user',
      type: 'info'
    },
  environment.modules.education
    ? {
      title: 'Education',
      smallText: 'EcoSure',
      url: '/education',
      icon: 'fa fa-university',
      type: 'warning'
    }
    : undefined,
  environment.modules.salesForce
    ? {
      title: 'Sales Force',
      smallText: 'Karabo',
      url: '/sales-force',
      icon: 'cui-task',
      type: 'logo-color'
    }
    : undefined,
  environment.modules.claims
    ? {
      title: 'Claim Requests',
      smallText: 'Karabo',
      url: '/claim-requests',
      icon: 'fa fa-plus',
      type: 'success'
    }
    : undefined,
  environment.modules.claims
    ? {
      title: 'Claim Processing',
      smallText: 'Karabo',
      url: '/claims/processing',
      icon: 'fa fa-pencil-square-o',
      type: 'warning'
    }
    : undefined,
  // environment.modules.claims
  //   ? {
  //     title: 'Find Claims',
  //     smallText: 'Karabo',
  //     url: '/claims/search',
  //     icon: 'fa fa-search',
  //     type: 'danger'
  //   }
  //   : undefined,
  environment.modules.reports
    ? {
      title: 'Reports',
      smallText: 'Karabo',
      url: '/reports',
      icon: 'fa fa-clipboard',
      type: 'info'
    }
    : undefined,
  environment.modules.commissions
    ? {
      title: 'Commissions',
      smallText: 'Mebanbo',
      url: '/commissions',
      icon: 'cui-task',
      type: 'warning'
    }
    : undefined,
].filter(nav => !!nav);
